var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3592 44.4811C28.0269 46.0211 26.1869 47.0345 25.8892 47.1111C24.9869 46.8767 9.88916 38.0256 9.88916 32V15.1111C14.4036 15.1111 24.3092 11.0689 25.8892 8.88892C27.4692 11.0689 37.3747 15.1111 41.8892 15.1111V20.4445",
    stroke: "#0068B5",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2224 31.1111H32.2224C32.1611 31.1111 32.1113 31.1608 32.1113 31.2222V41.6666C32.1113 41.728 32.1611 41.7778 32.2224 41.7778H46.2224C46.2838 41.7778 46.3336 41.728 46.3336 41.6666V31.2222C46.3336 31.1608 46.2838 31.1111 46.2224 31.1111Z",
    stroke: "#0068B5",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6667 31.1111V27.5555C43.6667 25.1011 41.6767 23.1111 39.2223 23.1111C36.7678 23.1111 34.7778 25.1011 34.7778 27.5555V31.1111",
    stroke: "#0068B5",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2222 35.5555V37.3333",
    stroke: "#0068B5",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9146 40.0367C27.3268 41.0734 26.0957 41.7501 25.8891 41.8034C25.2368 41.6345 14.3335 35.2423 14.3335 30.8901V23.1689",
    stroke: "#0068B5",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8857 17.7622C21.9513 16.7711 25.1569 15.2078 25.8891 14.1978C27.0302 15.7722 34.1846 18.6911 37.4446 18.6911V20.5",
    stroke: "#0068B5",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.2222,
    height: 40,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurity);
export default __webpack_public_path__ + "static/media/icon_security.ff769fec4bb7e571c0cb177d3b41b8d2.svg";
export { ForwardRef as ReactComponent };